
export const SEND_OTP_CODE_API = '/homePage/send-otp-code';
export const CHECK_OTP_CODE_API = '/homePage/check-otp-code';

export const SEND_OTP_CODE_TEST_API = '/homePage/test/send-otp-code';
export const CHECK_OTP_CODE_TEST_API = '/homePage/test/check-otp-code';

export const CHECK_REQUEST_STATUS_API = '/homePage/check-request-status';
export const CANCEL_PERMIT_OTP_API = '/homePage/cancel-permit';
export const CHECK_PERMIT_VALIDATION_DATE_API = '/homePage/check-permit-validation-date';
export const ADD_FILE_TO_REQUEST_API = '/homePage/add-file-to-request';
export const PRE_UPDATE_VEHICLE_DETAILS_API = '/homePage/pre-update-vehicle-details-otp';
export const UPDATE_VEHICLE_DETAILS_API = '/homePage/update-vehicle-details-otp';
export const PRE_RENEWED_PERMIT_OTP_API = '/homePage/pre-renewed-permit-request-otp';

export const REACT_APP_BASE_PERMIT_API_URL = 'https://lolamuni.com/citizenSticker/rest';
export const REACT_APP_BASE_PERMIT_API_URL_TEST = 'https://lolamuni.mifgaimtest.com/citizenSticker/rest';
export const REACT_APP_BASE_PERMIT_API_URL_NEW_API = 'https://1wml37bu0d.execute-api.eu-central-1.amazonaws.com/prod_1/citizenSticker/rest';
